/**
 * public feature routes — owned by web-public.
 * Add child routes here (this file and everything under features/public/ belong to the owner).
 * The pathless "publicFeature" route is registered once in src/app/router.tsx (frozen).
 */
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from '../../app/root-route';
import { isTvSearch } from './lib/matches';

export const publicFeature = createRoute({ getParentRoute: () => rootRoute, id: 'public' });

export const leaderboardRoute = createRoute({
  getParentRoute: () => publicFeature,
  path: '/t/$publicToken',
  component: lazyRouteComponent(() => import('./pages/LeaderboardPage'), 'LeaderboardPage'),
});

export const tvRoute = createRoute({
  getParentRoute: () => publicFeature,
  path: '/t/$publicToken/tv',
  component: lazyRouteComponent(() => import('./pages/TvModePage'), 'TvModePage'),
});

export const scorecardRoute = createRoute({
  getParentRoute: () => publicFeature,
  path: '/t/$publicToken/scorecard/$competitorId',
  component: lazyRouteComponent(() => import('./pages/ScorecardPage'), 'ScorecardPage'),
});

export const contestsRoute = createRoute({
  getParentRoute: () => publicFeature,
  path: '/t/$publicToken/contests',
  component: lazyRouteComponent(() => import('./pages/ContestsPage'), 'ContestsPage'),
});

export const matchesRoute = createRoute({
  getParentRoute: () => publicFeature,
  path: '/t/$publicToken/matches',
  // `?tv=1` = the clubhouse TV board of the bracket
  validateSearch: (search: Record<string, unknown>): { tv?: 1 } =>
    isTvSearch(search) ? { tv: 1 } : {},
  component: lazyRouteComponent(() => import('./pages/MatchesPage'), 'MatchesPage'),
});

export const groupsRoute = createRoute({
  getParentRoute: () => publicFeature,
  path: '/t/$publicToken/groups',
  component: lazyRouteComponent(() => import('./pages/GroupsPage'), 'GroupsPage'),
});

export const awardsRoute = createRoute({
  getParentRoute: () => publicFeature,
  path: '/t/$publicToken/awards',
  component: lazyRouteComponent(() => import('./pages/AwardsPage'), 'AwardsPage'),
});

/** audience screen of the award ceremony (projector / TV, follows the presenter) */
export const ceremonyRoute = createRoute({
  getParentRoute: () => publicFeature,
  path: '/t/$publicToken/ceremony',
  component: lazyRouteComponent(() => import('./pages/CeremonyPage'), 'CeremonyPage'),
});

export const publicRouteTree = publicFeature.addChildren([
  leaderboardRoute,
  tvRoute,
  scorecardRoute,
  contestsRoute,
  matchesRoute,
  groupsRoute,
  awardsRoute,
  ceremonyRoute,
]);
